import React, { memo } from 'react';

const MovieCard = memo(({ movie, onClick }) => (
    <div onClick={onClick} className="relative bg-white z-10 shadow-lg overflow-hidden rounded-lg">
        <img src={movie.poster} alt={movie.title} className="w-full h-40 object-cover" />
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black via-black/60 to-transparent p-2 flex items-end">
            <h5 className="text-xs font-semibold text-white text-left w-full leading-tight line-clamp-2">
                {movie.title}
            </h5>
        </div>
    </div>
));

MovieCard.displayName = 'MovieCard';

export default MovieCard;